import { Box, Typography, useTheme } from "@mui/material";
import { tokens, useHideMode } from "../theme";
import ProgressCircle from "./ProgressCircle";

const BucketBox = ({ amount, cap, title, icon, progress, increase }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const hideTheme = useHideMode();

    return (
        <Box width="100%" m="0 30px">
            <Box display="flex" justifyContent="space-between">
                <Box>
                    {icon}
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        {hideTheme.mode === "show" ? amount : '*'.repeat(9)}
                    </Typography>
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        --------------
                    </Typography>
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        {hideTheme.mode === "show" ? cap : '*'.repeat(9)}
                    </Typography>

                </Box>
                <Box>
                    <ProgressCircle progress={progress} size={75} />
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" mt="2px" mr="10%">
                <Typography variant="h5" sx={{ color: colors.blueAccent[500] }}>
                    {title}
                </Typography>

            </Box>
        </Box>
    );
};

export default BucketBox;

